import React, { useState, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Delete.module.css'
import { AppContext } from '../../../../providers/appProvider';
import Remove from "../../../../assets/Icon/Remove";
  
const Delete = ({ parserService, defaultAgent }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);

    const confirmDelete = () => { 
        parserService.remove(defaultAgent.id)
            .then((response) => {
                setIsModalOpen(false)
            })
            .catch((error) => {
                setIsModalOpen(false)
                app.setError("შეცდომა წაშლისას")
            });
    };

    const openDelete = () => {
        setIsModalOpen(true)
    }

    const closeDelete = () => {
        setIsModalOpen(false)
    }

    return ( <div>

            <span className={ cl.removeBtn } onClick={() => openDelete()} ><Remove/> წაშლა</span> 

            <Modal key={defaultAgent.id} size="medium" isOpen={isModalOpen} onClose={() => closeDelete()}>
                <div className={cl.modalHead }><h3>წაშლა</h3></div> 
                <div className={ cl.message } >გსურთ საიტის წაშლა?</div>
                <div className={ cl.buttons }>
                    <button className={ cl.removeBtnYes } onClick={confirmDelete}>დიახ მსურს!</button> 
                </div> 
            </Modal>
    

        </div> 
    );
};

export default Delete ;